import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import "@/plugins/default";
import "@/plugins/vue-currency-input";
import "@/plugins/vue-bootstrap";
import "@/plugins/vue-moment";
import "@/plugins/vue-axios";
import "@/plugins/vue-moment";
import "@/plugins/vue-scrollto";
import "@/plugins/vue-google-charts";
import { i18n } from "@/plugins/vue-i18n";

Vue.config.productionTip = false;

import "@/styles/main.scss";

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
